import { messages } from "@/shared/i18n";

/**
 * Google reCAPTCHA notice component
 *
 * Displays the required reCAPTCHA attribution text with links to
 * Google's Privacy Policy and Terms of Service (required by Google).
 *
 * @see https://developers.google.com/recaptcha/docs/faq#id-like-to-hide-the-recaptcha-badge.-what-is-allowed
 */
export function RecaptchaNotice() {
  return (
    <p className="text-center text-xs leading-relaxed text-pretty text-gray-400">
      {/* NB: These are Google reCAPTCHA policy links, not the app's own privacy/terms links.
          App-specific links live on the registration page: link-privacy-policy / link-terms-of-service */}
      {messages.common.recaptcha.footerText}{" "}
      <a
        className="text-gray-500 underline hover:text-gray-700"
        data-testid="link-google-privacy"
        href="https://policies.google.com/privacy?hl=hu"
        rel="noopener noreferrer"
        target="_blank"
      >
        {messages.common.recaptcha.privacy}
      </a>{" "}
      {messages.common.recaptcha.and}{" "}
      <a
        className="text-gray-500 underline hover:text-gray-700"
        data-testid="link-google-terms"
        href="https://policies.google.com/terms?hl=hu"
        rel="noopener noreferrer"
        target="_blank"
      >
        {messages.common.recaptcha.terms}
      </a>{" "}
      {messages.common.recaptcha.apply}
    </p>
  );
}
